module.exports = __webpack_public_path__ + "static/img/photo-store-locator_m.a772bcf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/medium/photo-store-locator_m.jpg
// module id = AxXu
// module chunks = 1